function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Oznakowania na opakowaniach");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13 13v17.752A2.256 2.256 0 0 0 15.251 33h15.5A2.249 2.249 0 0 0 33 30.752V13zm18 18H15V15h16z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22 21h2v7h-2zm1-2a.99.99 0 0 1-1-1 1.049 1.049 0 0 1 .29-.71 1.154 1.154 0 0 1 .33-.21.956.956 0 0 1 .58-.061.672.672 0 0 1 .18.061.757.757 0 0 1 .18.09 1.575 1.575 0 0 1 .15.12A1.049 1.049 0 0 1 24 18a.838.838 0 0 1-.08.38 1.168 1.168 0 0 1-.21.33 1.154 1.154 0 0 1-.33.21A1 1 0 0 1 23 19z"
});

var SvgBoxSigns = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBoxSigns, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/boxSigns.dfce3e54.svg";
export { ForwardRef as ReactComponent };